import { PayloadAction, SliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { newStateFromFlatBooking } from '../components/utils/stateHelper';
import { setBookingStateFromFlat } from './gunOptionSlice';

interface GlobalInterface {
    lang: string,
    referrer: string,
    maxStepReached: number,
    currentStep: number,
    domain: string,
}

export const globalSlice = createSlice<GlobalInterface, SliceCaseReducers<GlobalInterface>>({
    name: 'globals',
    initialState: {
        lang: 'nl',
        referrer: document.location.pathname,
        maxStepReached: 1,
        currentStep: 1,
        domain: document.location.host,
    },
    reducers: {
        /**
         * Pass as object with the to-change properties
         */
        setGlobals: (state, action) => {
            return {...state, ...action.payload};
        },
        /**
         * Input string for language
         */
        setBookingLanguage: (state, action) => {
            state.lang = action.payload;
        },
        /**
         * Input string for referrer
         */
        setReferrer: (state, action) => {
            state.referrer = action.payload;
        },
        setStep: (state, action) => {
            const newStepNum = action.payload;
            // Don't allow skipping steps. That would break things
            if (newStepNum >= 1 && newStepNum <= state.maxStepReached) {
                state.currentStep = newStepNum;
            }
        },
        prevStep: (state) => {
            if (state.currentStep > 1) {
                state.currentStep -= 1;
            }
        },
        nextStep: (state) => {
            if (state.currentStep < 5) {
                state.currentStep += 1;
                if (state.currentStep > state.maxStepReached) {
                    state.maxStepReached += 1;
                }
            }
        },
    },
    extraReducers(builder) {
        builder.addCase(setBookingStateFromFlat, (state, action) => {
            const newState = newStateFromFlatBooking(state, action.payload);
            return newState as GlobalInterface;
        });
    },
});

export const { setGlobals, setBookingLanguage, setReferrer, setStep, prevStep, nextStep } = globalSlice.actions;
export default globalSlice.reducer;